import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { useEffect, useRef, useState } from 'react';
import { GETDESTINATION, ORGANIZATIONSTATIONADDEDIT, ORGANIZATIONSTATIONDELETERESTORE } from '../../../Utils/conts.js';
import { withRFSToken } from '../../../Services/axios';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Trash from "../../../assets/images/delete.svg";
import Edit from "../../../assets/images/edit.png";
const StationSettings = () => {
  const gridRef = useRef(null);
  const isMounted = useRef(false);
  const [getDestination, setGetDestination] = useState([]);
  const [selectedOrigin, setSelectedOrigin] = useState([]);
  const [addStationModal, setAddStationModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [allData, setAlldata] = useState(null);
  const [confModal, setConfModal] = useState(false);
  useEffect(() => {
    if (isMounted.current) return;
    fetchDestination();
    loadGrid();
    isMounted.current = true;
  }, []);

  const fetchDestination = async () => {
    try {
      const res = await withRFSToken.post(GETDESTINATION, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.port_code,
            label: item.port_code,
            address: item.address,
            station_id: item.station_id
          })) : [];
          setGetDestination(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const closeAddStationModal = () => {
    setAddStationModal(false);
  }

  const handleAddStationModal = (confirm) => {
    if (confirm) {
      handleAddStation();
      setAddStationModal(false);
    } else {
      setDeleteId(0);
      closeAddStationModal();
    }
  }

  const handleAddStation = async () => {
    try {
      const res = await withRFSToken.post(ORGANIZATIONSTATIONADDEDIT, {
        station_id: selectedOrigin.station_id,
      });
      if (res.data.response_code === 200) {
        loadGrid();
        setSelectedOrigin([]);
        toast.success(res.data.response_msg);
      } else {
        toast.error(res.data.response_msg || 'Failed to update status');
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error('Something went wrong');
    }
  }

  const addStation = () => {
    setAddStationModal(true);
  }

  const loadGrid = () => {
    if (gridRef.current) {
      const token = 'Bearer ' + localStorage.airlinetoken;
      const source = {
        datatype: 'json',
        url: `${process.env.REACT_APP_RFS_URL}organization-station/list`,
        root: 'response_data',
        cache: false,
        datafields: [
          { name: 'org_station_id', type: 'string' },
          { name: 'org_id', type: 'string' },
          { name: 'station_id', type: 'string' },
          { name: 'station_name', type: 'string' },
          { name: 'total_warehouse', type: 'string' },
          { name: 'user_count', type: 'string' },
          { name: 'door_configuration', type: 'string' },
        ],
        beforeSend: (jqXHR) => {
          jqXHR.setRequestHeader('Authorization', token);
        },
        filter: function (allfilters) {
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          setAlldata(data.Rows);
        }
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        {
          text: 'Action', datafield: '', width: '8%', filtertype: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            return `<div class="grid_actions"><img class="door_delete" src="${Trash}"/></div>`;
          }
        },
        { text: 'Station Name', datafield: 'station_name', width: '15%' },
        { text: 'User Count', datafield: 'user_count', width: '10%' },
        { text: 'Total Warehouses', datafield: 'total_warehouse', width: '12%' },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 800,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        pageable: true,
        pageSize: 50,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).off('click', '.door_delete').on('click', '.door_delete', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        setDeleteId(rowData.org_station_id);
        setConfModal(true);
      });
    }
  };

  const handleConfirmation = (confirm) => {
    if (confirm) {
      handleStationDelete(deleteId)
      setConfModal(false);
    } else {
      setDeleteId(0);
      closeConfirm();
    }
  };

  const closeConfirm = () => {
    setConfModal(false);
  }

  const handleStationDelete = async (commentId) => {
    const res = await withRFSToken.post(ORGANIZATIONSTATIONDELETERESTORE, { org_station_id: deleteId })
    if (res.data.response_code == 200) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        loadGrid();
        closeConfirm();
        // refreshPageData();
      } else {
        toast.error(res.data.response_msg);
      }
    } else {
      toast.error(res.data.response_msg);
    }
  };

  return (
    <>
      {/* <div className="">
        <Header logo_url='/HandlerAdmin' sBackUrl='/HandlerAdmin' mode='SAS' />
        <div className="main-panel">

          <div className="row">
            <LeftSettings mode='HSA' /> */}

            <div className='col-9 col-xxl-9 stting_right'>
              <div className='settingbg_right'>
                <h4>Station Setting</h4>
                <p>Set your notification preferences for when you are in or away from the dashboard.</p>
                <div className='d-flex justify-content-between'>
                  <div>
                    <Button variant="primary createplan" onClick={() => addStation()}>
                      <FontAwesomeIcon icon={faPlus} /> Add Station
                    </Button>
                  </div>
                  <div className='rastatus'>
                    {/* <span>Status : </span>
                        <Form.Select>
                          <option>All</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </Form.Select> */}
                  </div>
                </div>

                <div ref={gridRef} className="staion_grid" />

              </div>
            </div>
          {/* </div>
        </div>
      </div> */}
      <Modal show={addStationModal} onHide={closeAddStationModal} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeAddStationModal}></Modal.Header>
        <Modal.Body>
          <>
            <h3> Add Station </h3>
            <Form.Label>Station List</Form.Label>
            <Select
              options={getDestination}
              onChange={(selected) => {
                //const selectedIds = selected.map(item => item.value);
                // setSelectedOrigin(selectedIds);
                setSelectedOrigin(selected)
              }}
              placeholder="Origin"
              className='MultiSelect'
              name="origin"
              value={selectedOrigin}
            />
          </>
          
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleAddStationModal(false)}> No</Button>
            <Button variant="primary" onClick={() => handleAddStationModal(true)}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
        <Modal.Body>
          <h3>The Station will be deleted. </h3>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
            <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default StationSettings;